import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin, Mail, ShieldCheck, Truck, RotateCcw, CreditCard } from "lucide-react";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

const cols = [
  { title: "Shop", links: [["Carp Fishing", "/shop?discipline=Carp%20Fishing"], ["Coarse Fishing", "/shop?discipline=Coarse%20Fishing"], ["Predator Fishing", "/shop?discipline=Predator%20Fishing"], ["Sea Fishing", "/shop?discipline=Sea%20Fishing"], ["Deals & Bundles", "/bundles"], ["Brands", "/brands"]] },
  { title: "Help", links: [["Delivery Info", "/delivery"], ["Returns", "/delivery"], ["Contact Us", "/contact"], ["FAQs", "/delivery"], ["My Account", "/account"], ["Track Order", "/account"]] },
  { title: "Company", links: [["Our Story", "/about"], ["Fishing Guides", "/blog"], ["Gift Cards", "/about"], ["Careers", "/about"], ["Privacy Policy", "/about"], ["Terms", "/about"]] },
];

const trust = [
  [ShieldCheck, "Secure Checkout"],
  [Truck, "Fast UK Delivery"],
  [RotateCcw, "Easy 30-Day Returns"],
  [CreditCard, "Klarna & Clearpay"],
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email }); toast.success("You're on the list. Tight lines!"); setEmail(""); }
    catch { toast.error("Please enter a valid email."); }
  };

  return (
    <footer className="mt-24 border-t border-border bg-card">
      <div className="border-b border-border">
        <div className="container-furn grid grid-cols-2 gap-6 py-8 md:grid-cols-4">
          {trust.map(([Icon, label]) => (
            <div key={label} className="flex items-center gap-3">
              <Icon className="h-6 w-6 text-accent" />
              <span className="text-sm font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="container-furn grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-6">
        <div className="lg:col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">Specialist fishing tackle for carp, coarse, predator and sea anglers. Passionate about angling, trusted on the bank.</p>
          <div className="mt-5 space-y-2 text-sm text-muted-foreground">
            <p className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-accent" /> Unit 10, Blackhall Industrial Park, South Woodham Ferrers, CM3 5UW</p>
            <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> sales@furnangling.co.uk</p>
          </div>
          <div className="mt-5 flex gap-3">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="grid h-9 w-9 place-items-center border border-border text-muted-foreground hover:border-accent hover:text-accent transition-colors"><Icon className="h-4 w-4" /></a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="overline mb-4">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h4 className="overline mb-4">Newsletter</h4>
          <p className="mb-3 text-sm text-muted-foreground">Latest gear, offers & bankside tips.</p>
          <form onSubmit={subscribe} className="flex flex-col gap-2">
            <input data-testid="footer-newsletter-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" type="email" className="border border-border bg-secondary/60 px-3 py-2.5 text-sm outline-none focus:border-accent transition-colors" />
            <button data-testid="footer-newsletter-submit" className="bg-accent py-2.5 text-xs font-bold uppercase tracking-widest text-accent-foreground hover:brightness-110 transition-[filter]">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-furn flex flex-col items-center justify-between gap-3 py-5 text-xs text-muted-foreground sm:flex-row">
          <p>© {new Date().getFullYear()} Furn Angling. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-3 font-semibold tracking-wide">
            <span>VISA</span><span>MASTERCARD</span><span>PAYPAL</span><span>KLARNA</span><span>CLEARPAY</span><span> PAY</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
